import React from "react";
import "../../../../../Assets/Styles/ErrorModal.scss";

const ErrorModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <main className="error-modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="modal-body">
        <section className="modal-head">
          <h1>
            {translateText("delete")} {translateText("failed").toLowerCase()}
          </h1>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        {props.Type === "security profile(s)" ? (
          <h3>{translateText("security_profiles_bulk_delete_error") + ":"}</h3>
        ) : (
          <h3>{translateText("acls_bulk_delete_error") + ":"}</h3>
        )}
        <section className="modal-list">
          {props.Data.map((Item, idx) => (
            <p key={idx}>{Item}</p>
          ))}
        </section>
        <button onClick={() => props.Close()}>{translateText("got_it")}</button>
      </div>
    </main>
  );
};

export default ErrorModal;
